function updateMyShippingBar() {
  const bar = document.querySelector('.my-shipping-progress');
  if (!bar) return;

  // Convert threshold to cents
  const thresholdCents = parseFloat(bar.dataset.threshold) * 100;
  const totalCents = parseFloat(bar.dataset.total);

  const fill = bar.querySelector('.my-progress-fill');
  if (!fill) return;

  // Calculate percent fill
  const percent = Math.min((totalCents / thresholdCents) * 100, 100);
  fill.style.width = percent + "%";

  // Calculate remaining amount
  const remainingCents = Math.max(thresholdCents - totalCents, 0);
  const remainingFormatted = `$${(remainingCents / 100).toFixed(2)}`;

  // Update fill text (optional inside the bar)
  fill.textContent = remainingFormatted;

  // Update the free shipping message
  const messageSpan = document.querySelector('.free-shipping-bar .text-subdued');
  if (messageSpan) {
    if (remainingCents > 0) {
      messageSpan.textContent = `Spend ${remainingFormatted} more and get free shipping!`;
      bar.classList.remove('is-filled');
      bar.classList.add('not-filled');
    } else {
      messageSpan.textContent = `You have free shipping!`;
      bar.classList.add('is-filled');
      bar.classList.remove('not-filled');
    }
  }
}

// Initial load
updateMyShippingBar();

// Update on cart change
document.addEventListener("cart:change", (e) => {
  requestAnimationFrame(() => {
    const bar = document.querySelector('.my-shipping-progress');
    if (bar) {
      const cart = e.detail.cart;

      const itemsTotal = cart.items
        .filter(i => i.requires_shipping)
        .reduce((sum, i) => sum + i.final_line_price, 0);

      const discount = cart.cart_level_discount_applications
        .reduce((sum, d) => sum + d.total_allocated_amount, 0);

      bar.dataset.total = itemsTotal - discount;
    }

    updateMyShippingBar();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const observeQuickBuy = new MutationObserver(() => {
    const modal = document.querySelector(".quick-buy-modal");
    const afterpayEl = modal?.querySelector(".afterpay-placement");

    if (afterpayEl && window.AfterpayMessagingLib) {
      try {
        window.AfterpayMessagingLib.refresh();
      } catch (e) {
        console.warn("Afterpay messaging refresh failed:", e);
      }
    }
  });

  observeQuickBuy.observe(document.body, { childList: true, subtree: true });
});

/*
 * Size pre-selection removal:
 * After a variant:change event (which fires after product:rerender replaces buy-buttons),
 * ensure the add-to-cart button reflects the correct state. This handles an edge case where
 * the server re-render may not detect that a size was already selected by the user.
 */
document.addEventListener('variant:change', function(event) {
  const form = event.target;
  if (!form || !form.tagName) return;

  const variantPicker = document.querySelector('variant-picker[data-size-required][form-id="' + form.id + '"]');
  if (!variantPicker) return;

  const variant = event.detail?.variant;
  const buyButtons = form.querySelector('buy-buttons');
  if (!buyButtons) return;

  const button = buyButtons.querySelector('button[type="submit"]');
  if (!button) return;

  if (variant && variant.id && variant.available) {
    button.disabled = false;
    const template = buyButtons.getAttribute('template') || '';
    if (template.includes('pre-order')) {
      button.textContent = window.themeVariables?.strings?.preOrder || 'Pre-order';
    } else {
      button.textContent = window.themeVariables?.strings?.addToCart || 'Add to cart';
    }
  } else if (variant && variant.id && !variant.available) {
    button.disabled = true;
    button.textContent = window.themeVariables?.strings?.soldOut || 'Sold out';
  }
});

/*
 * Sticky ATC size selector:
 * Proxies size button clicks in the sticky bar to the corresponding radio in the main
 * variant picker, so the VariantPicker JS handles the full selection/re-render cycle.
 * Uses document-level delegation because the sticky bar is fully replaced by
 * product-rerender on every variant change.
 */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-sticky-size-btn]');
  if (!btn || btn.classList.contains('is-unavailable')) return;

  const optionPosition = btn.dataset.optionPosition;
  const optionValueId = btn.dataset.optionValue;
  const stickyBar = btn.closest('product-sticky-bar');
  if (!stickyBar) return;

  const formId = stickyBar.getAttribute('form');
  const variantPicker = document.querySelector('variant-picker[form-id="' + formId + '"]');
  if (!variantPicker) return;

  // Find the matching radio in the main picker by option position + value (option_value.id)
  const radio = variantPicker.querySelector(
    'input[data-option-position="' + optionPosition + '"][value="' + CSS.escape(optionValueId) + '"]'
  );

  // Optimistic: mark selection instantly before re-render
  stickyBar.querySelectorAll('[data-sticky-size-btn]').forEach(function (b) {
    b.classList.toggle('is-selected', b === btn);
  });

  if (radio && !radio.checked) {
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
});